/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Samples_PhoneInputs */

const en_samples_phone = /** @type {(inputs: Samples_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phone`)
};

const es_samples_phone = /** @type {(inputs: Samples_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefono`)
};

/**
* | output |
* | --- |
* | "Phone" |
*
* @param {Samples_PhoneInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_phone = /** @type {((inputs?: Samples_PhoneInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_PhoneInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_phone(inputs)
	return es_samples_phone(inputs)
});